<script>
import { store } from './store.js'
import LayerText from './LayerText.vue'
import LayerDynText from './LayerDynText.vue'
import LayerRect from './LayerRect.vue'
import LayerImage from './LayerImage.vue'
import LayerDynImage from './LayerDynImage.vue'
import LayerTaxonomy from './LayerTaxonomy.vue'

export default {
  components: {
    LayerText,
    LayerDynText,
    LayerImage,
    LayerRect,
    LayerDynImage,
    LayerTaxonomy,
  },
  props: ['item', 'index'],
  data() {
    return {
      store
    }
  },
  mounted() {

  },
  updated() {
    
  },

   computed: {
    // a computed getter
    mediaId() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

    mediaDiv() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

    selectedClass() {
      var output = "no";
      if(this.item.id == store.targetid){
        output = "yes";
      }

      return output;
    },

    isClosed(){
      if (this.item.id == store.targetid) {
        return false;
      } else {
        return true;
      }
    }

  },

  methods: {
    setid() {
      store.targetid = this.item.id;
      jQuery("#opengraphiqtemplates_selected").val(this.item.id);
    },

    deletelayer() {
      let confirmAction = confirm("Are you sure to delete this element?");
      if (confirmAction){
        let tempid = this.item.id;
        var tmparray = jQuery.grep(store.domelements, function(e){ 
            return e.id != tempid; 
          });
        store.domelements = tmparray;
        store.targetid = "-1";
        jQuery("#opengraphiqtemplates_selected").val("-1");
      }
    },

    togglecloselayer() {
      if ( ! this.isClosed ) {
        store.targetid = "-1";
        jQuery("#opengraphiqtemplates_selected").val("-1");
      } else {
        store.targetid = this.item.id;
        jQuery("#opengraphiqtemplates_selected").val(this.item.id);
      }
    },

  },

  watch: {
  },
};
</script>

<template>

    <div :id="item.id" class="og-postbox" :class="{closed:isClosed}" :data-selected="selectedClass" style="" @click="setid()">

    <div class="og-postbox-header">
						<div class="handle-actions hide-if-no-js">
							<button type="button" class="handle-delete" aria-disabled="false" aria-describedby="postimagediv-handle-delete-description" @click.stop="deletelayer()">
								<span class="screen-reader-text">Delete</span>
								<span class="delete-indicator" aria-hidden="true" title="Delete layer"></span>
							</button>
            			</div>
            
            <h2 class="handle">{{item.layername}}</h2>
						<div class="handle-actions hide-if-no-js">
							<button type="button" class="handlediv" aria-expanded="true" @click.stop="togglecloselayer()">
								<span class="screen-reader-text">Toggle panel: Featured image</span>
								<span class="toggle-indicator" aria-hidden="true"></span>
							</button>
						</div>

		</div><!-- .postbox_temp-header -->

        
        <LayerText v-if="item.type == 'text'" :item="item" />

        <LayerDynText v-if="item.type == 'dyntext'" :item="item" />

        <LayerRect v-if="item.type == 'rect'" :item="item" />

        <LayerImage v-if="item.type == 'image'" :item="item" />

        <LayerDynImage v-if="item.type == 'dynimage'" :item="item" />

        <LayerTaxonomy v-if="item.type == 'taxonomy'" :item="item" />
    
    </div><!-- .postbox_temp -->	

</template>